import React from "react";
import { useNavigate } from "react-router-dom";

const AdminAnalysis = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("authToken"); // Adjust if needed
    navigate("/login");
  };

  return (
    <div className=" bg-gray-100 text-gray-800">
      
      <main className="flex-1 p-12 ml-64 min-h-screen">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight drop-shadow-sm">Analysis Dashboard</h1>
          <button
            onClick={handleLogout}
            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2 rounded-xl shadow-md transition duration-300 transform hover:scale-105"
          >
            Logout
          </button>
        </div>

        <section className="bg-white rounded-2xl shadow-lg p-8">
          <p className="text-lg text-gray-700">
            Here you can view detailed analytics and reports.
          </p>

          <div className="mt-6 text-gray-500 italic">
            Analysis dashboard UI coming soon...
          </div>
        </section>
      </main>
    </div>
  );
};

export default AdminAnalysis;
